import QuickDataModal from './QuickDataModal';
export default QuickDataModal;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickDataModal/index.js